import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { Suspendable } from '@components/common/Suspendable';

import { ROUTES } from '@constants';

const IframeModeController = Suspendable(
  lazy(() =>
    import('@modules/iframe/controller/IframeModeController').then(
      (module) => ({
        default: module.default,
      })
    )
  )
);
export const IframeMode: RouteObject[] = [
  {
    path: ROUTES.IFRAME_MODE.ROOT,
    element: <IframeModeController />,
  },
];
